import { render, staticRenderFns } from "./topTrim.vue?vue&type=template&id=09a0311a&"
import script from "./topTrim.vue?vue&type=script&lang=js&"
export * from "./topTrim.vue?vue&type=script&lang=js&"
import style0 from "./topTrim.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports